import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
	{
		id: 0,
		title: 'Home',
		type: 'basic',
		icon: 'heroicons_outline:home',
		link: '/main',
	},
	{
		id: 0,
		title: 'Atendimento',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'WhatsApp Business',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-comments' },
				link: '/modules/whatsapp-business',
				exactMatch: true,
			},
			{
				id: 0,
				title: 'WhatsApp Business - Messages',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-comments' },
				link: '/modules/whatsapp-business/5511988131269',
				exactMatch: true,
			},
			{
				id: 0,
				title: 'WhatsApp Business - Configuration',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-comments' },
				link: '/modules/whatsapp-business/configuration',
				exactMatch: true,
			},
			{
				id: 0,
				title: 'WhatsApp Api',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-comments' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/modules/whatsapp-api' },
				exactMatch: true,
			},
		],
	},
	{
		id: 0,
		title: 'Aplicação',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Outlook',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 far fa-mail-bulk' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/modules/outlook' },
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Trello',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fab fa-trello' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/modules/trello' },
				exactMatch: true,
			},
		],
	},
	{
		id: 0,
		title: 'Gerenciador de Arquivos',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Vibra-Stop',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 far fa-cloud' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/modules/filemanager/vibrastop' },
				exactMatch: true,
			},
		],
	},
	{
		id: 0,
		title: 'Marketing',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Instagram',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fab fa-instagram' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/modules/marketing/instagram' },
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Facebook',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fab fa-facebook-square' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/modules/marketing/facebook' },
				exactMatch: true,
			},
			{
				id: 0,
				title: 'E-mail',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fal fa-paper-plane' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/modules/marketing/mail' },
				exactMatch: true,
			},
			{
				id: 0,
				title: 'SMS',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 fal fa-paper-plane' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/modules/marketing/sms' },
				exactMatch: true,
			},
		],
	},
	{
		id: 0,
		title: 'Venda',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Produtos',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 far fa-barcode' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/sales/products' },
				exactMatch: true,
			},
			// {
			// 	id: 0,
			// 	title: 'Balcão',
			// 	subtitle: '',
			// 	type: 'basic',
			// 	classes: { icon: 'icon-size-4 far fa-desktop' },

			// 	link: '/access-denied',
			// 	badge: {
			// 		title: '',
			// 		classes: 'px-1 text-white rounded-full far fa-lock',
			// 	},
			// 	queryParams: { path: '/sales/counter' },
			// 	exactMatch: true,
			// },
			{
				id: 0,
				title: 'Serviços',
				subtitle: '',
				type: 'basic',
				classes: { icon: 'icon-size-4 far fa-tools' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: { path: '/sales/services' },
				exactMatch: true,
			},
		],
	},
	{
		id: 0,
		title: 'Administração',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Cadastros',
				subtitle: '',
				type: 'collapsable',
				classes: { icon: 'icon-size-4 fa fa-list-alt' },
				children: [
					{
						id: 0,
						title: 'Clientes',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-users' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/accounts' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Fornecedores',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-hospital' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/providers' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Representantes',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fa fa-handshake' },
						children: [
							{
								id: 0,
								title: 'Comissão',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-comments-dollar' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: { path: '/management/representatives/commission' },
								exactMatch: true,
							},
						],
					},
					{
						id: 0,
						title: 'Funcionários',
						type: 'basic',
						classes: { icon: 'icon-size-4 far fa-users' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/employees' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Transportadoras',
						type: 'basic',
						classes: { icon: 'icon-size-4 far fa-truck' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/carriers' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Fabricantes',
						type: 'basic',
						classes: { icon: 'icon-size-4 far fa-industry-alt' },
						icon: 'heroicons_outline:document-report',
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/manufacturers' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Opções auxiliares',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fa fa-clipboard' },
						children: [
							{
								id: 0,
								title: 'Tipos de contatos',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-bullhorn' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/auxiliaryOptions/contactsTypes',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Tipos de endereços',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-location-dot' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/auxiliaryOptions/addressesTypes',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Tipos de telefones',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-phone' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/auxiliaryOptions/phonesTypes',
								},
								exactMatch: true,
							},
						],
					},
				],
			},
			{
				id: 0,
				title: 'Produtos',
				subtitle: '',
				type: 'collapsable',
				classes: { icon: 'icon-size-4 fa-solid fa-barcode' },
				children: [
					{
						id: 0,
						title: 'Gerenciar',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-cubes' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/products' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Opções auxiliares',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fa fa-clipboard' },
						children: [
							{
								id: 0,
								title: 'Grupos de produtos',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-sitemap' },
								link: '/management/auxiliaryOptions/productGroup',
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Unidades de medidas',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa  fa-flask' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: { path: '/management/auxiliaryOptions/unitsMeasures' },
								exactMatch: true,
							},
						],
					},
				],
			},
			{
				id: 0,
				title: 'Estoque',
				subtitle: '',
				type: 'collapsable',
				classes: { icon: 'icon-size-4 fa fa-cube' },
				children: [
					{
						id: 0,
						title: 'Movimentações',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-external-link' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/inventory/movements' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Ajustes',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-arrows-alt' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/inventory/settings' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Transferências',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-exchange' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/inventory/transfers' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Cotações',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-clipboard' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/inventory/quotations' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Compras',
						type: 'basic',
						classes: { icon: 'icon-size-4 far fa-shopping-basket' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/inventory/shopping' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Trocas e Develouções',
						type: 'basic',
						classes: { icon: 'icon-size-4 fas fa-reply-all' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/inventory/exchangesReturns' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Opções auxiliares',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fa fa-clipboard' },
						children: [
							{
								id: 0,
								title: 'Situações de compras',
								type: 'basic',
								classes: { icon: 'icon-size-4 fal fa-list-ul' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/inventory/auxiliaryOptions/purchasingSituations',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Modelo de e-mail',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-envelope' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/inventory/auxiliaryOptions/mailsModels',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Configurações',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-cogs' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/inventory/auxiliaryOptions/settings',
								},
								exactMatch: true,
							},
						],
					},
				],
			},
			{
				id: 0,
				title: 'Financeiro',
				subtitle: '',
				type: 'collapsable',
				classes: { icon: 'icon-size-4 fa fa-sack-dollar' },
				children: [
					{
						id: 0,
						title: 'Contas a Pagar',
						type: 'basic',
						icon: 'heroicons_outline:arrow-trending-down',
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/financial/billsPay' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Contas a Receber',
						type: 'basic',
						icon: 'heroicons_outline:arrow-trending-up',
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/financial/billsReceive' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Fluxo de Caixa',
						type: 'basic',
						classes: { icon: 'icon-size-4 far fa-chart-bar' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/management/financial/cashFlow' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Boletos bancários',
						subtitle: '',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fas fa-barcode' },
						children: [
							{
								id: 0,
								title: 'Gerenciar',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-cubes' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: { path: '/management/financial/bankSlips/manage' },
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Exportar Remessa',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-cloud-download' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/bankSlips/exportRemittance',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Importar retorno',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-cloud-upload' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/bankSlips/importReturn',
								},
								exactMatch: true,
							},
						],
					},
					{
						id: 0,
						title: 'Opções auxiliares',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fa fa-clipboard' },
						children: [
							{
								id: 0,
								title: 'Caixa',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-laptop' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/cashier',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Contas bancárias',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-piggy-bank' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/bankAccounts',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Tipo de pagamento',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-money-bill' },
								link: '/management/financial/auxiliaryOptions/paymentType',
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Formas de pagamento',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-money-bill' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/paymentMethods',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Plano de contas',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-sitemap' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/planAccounts',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Centro de Custos',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-circle-dollar-to-slot' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/costCenter',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Conciliação bancária',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa-regular fa-hand-holding-dollar' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/bankReconciliation',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Controle de Cheques',
								type: 'basic',
								classes: { icon: 'icon-size-4 far fa-money-check-dollar' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/checkControl',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Transferência',
								type: 'basic',
								classes: { icon: 'icon-size-4 fal fa-right-left' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/transfer',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Modelos de E-mail',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-envelope' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/mailsModels',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Configurações',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-cogs' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/auxiliaryOption/settings',
								},
								exactMatch: true,
							},
						],
					},
				],
			},
			{
				id: 0,
				title: 'Nota fiscais',
				subtitle: '',
				type: 'collapsable',
				classes: { icon: 'icon-size-4 fa fa-file-invoice' },
				children: [
					{
						id: 0,
						title: 'Gerenciar NF-e',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa  fa-shopping-cart' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: {
							path: '/management/financial/taxNote/manageNFe',
						},
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Gerenciar NFS-e',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-file-lines' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: {
							path: '/management/financial/taxNote/manageNFSe',
						},
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Gerenciar NFC-e',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-qrcode' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: {
							path: '/management/financial/taxNote/manageNFCe',
						},
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Opções auxiliares',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fa fa-clipboard' },
						children: [
							{
								id: 0,
								title: 'Importar XML',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-file-code' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/taxNote/auxiliaryOption/importedXml',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Certificado Digital',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-certificate' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/taxNote/auxiliaryOption/digitalCertificate',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Naturezas de operações',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-exchange' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/taxNote/auxiliaryOptions/natureOperation',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'NCM - Tabeta IBPT',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-barcode' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/taxNote/auxiliaryOption/ncmTabetaIbpt',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Atividades de serviços',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-screwdriver-wrench' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/taxNote/auxiliaryOption/serviceActivities',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Modelos de e-mails',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-envelope' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/taxNote/auxiliaryOption/mailsModels',
								},
								exactMatch: true,
							},
							{
								id: 0,
								title: 'Configurações',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-cog' },
								link: '/access-denied',
								badge: {
									title: '',
									classes: 'px-1 text-white rounded-full far fa-lock',
								},
								queryParams: {
									path: '/management/financial/taxNote/auxiliaryOption/settings',
								},
								exactMatch: true,
							},
						],
					},
				],
			},
		],
	},
	{
		id: 0,
		title: 'Relatório',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Faturamento',
				type: 'collapsable',
				classes: { icon: 'icon-size-4 far fa-chart-mixed' },
				children: [
					{
						id: 0,
						title: 'Completo',
						type: 'basic',
						icon: 'heroicons_outline:chart-bar-square',
						link: '/report/billing/full',
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Anual',
						type: 'basic',
						icon: 'heroicons_outline:chart-bar-square',
						link: '/report/billing/yearly',
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Mensal',
						type: 'basic',
						icon: 'heroicons_outline:chart-bar-square',
						link: '/report/billing/monthly',
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Diário',
						type: 'basic',
						icon: 'heroicons_outline:chart-bar-square',
						link: '/report/billing/daily',
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Configuração',
						type: 'basic',
						icon: 'heroicons_outline:cog-6-tooth',
						link: '/report/billing/config',
						exactMatch: true,
					},
				],
			},
			{
				id: 0,
				title: 'Vendas',
				type: 'basic',
				classes: { icon: 'icon-size-4 far fa-shopping-cart' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/report/billing/sales',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Ordens de serviços',
				type: 'basic',
				classes: { icon: 'icon-size-4 far fa-briefcase' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/report/billing/serviceOrders',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Estoque',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-cube' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/report/billing/inventory',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Financeiro',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-sack-dollar' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/report/billing/financial',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Notas fiscais',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-file-invoice' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/report/billing/invoices',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Atendimentos',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-comments' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/report/billing/care',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Logs do sistema',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-glasses' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/report/billing/systemLogs',
				},
				exactMatch: true,
			},
		],
	},
	{
		id: 0,
		title: 'Configuração',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Gerais',
				type: 'collapsable',
				classes: { icon: 'icon-size-4 fal fa-cog' },
				children: [
					{
						id: 0,
						title: 'Menus & Sub-Menus',
						type: 'basic',
						classes: { icon: 'icon-size-4 far fa-tree' },
						link: '/access-denied',
						badge: {
							title: '',
							classes: 'px-1 text-white rounded-full far fa-lock',
						},
						queryParams: { path: '/setting/menus/manager' },
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Opções auxiliares',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fa fa-clipboard' },
						children: [
							{
								id: 0,
								title: 'Estado',
								type: 'basic',
								classes: { icon: 'icon-size-4 fa fa-flag' },
								link: '/setting/status/manager',
								exactMatch: true,
							},
						],
					},
				],
			},
			{
				id: 0,
				title: 'Meu plano',
				type: 'basic',
				classes: { icon: 'icon-size-4 fas fa-star-half-alt' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/settings/myPlan',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Usuários',
				type: 'collapsable',
				classes: { icon: 'icon-size-4 fa fa-user' },
				children: [
					{
						id: 0,
						title: 'Gerenciar',
						type: 'basic',
						classes: { icon: 'icon-size-4 fa fa-users' },
						link: '/admin/user',
						exactMatch: true,
					},
					{
						id: 0,
						title: 'Opções auxiliares',
						type: 'collapsable',
						classes: { icon: 'icon-size-4 fa fa-clipboard' },
						children: [
							{
								id: 0,
								title: 'Tipos de usuários',
								type: 'basic',
								classes: { icon: 'icon-size-4 fas fa-user-tag' },
								link: '/setting/userType/manager',
								exactMatch: true,
							},
						],
					},
				],
			},
			{
				id: 0,
				title: 'Dados da empresa',
				classes: { icon: 'icon-size-4 fa fa-suitcase' },
				type: 'basic',
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/settings/companyData',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Marca da empresa',
				classes: { icon: 'icon-size-4 fa fa-image' },
				type: 'basic',
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/settings/companyBrand',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Empresas / Lojas',
				classes: { icon: 'icon-size-4 fa fa-store' },
				type: 'basic',
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/settings/companiesStores',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Certificado digital',
				classes: { icon: 'icon-size-4 fa fa-certificate' },
				type: 'basic',
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/settings/digitalCertificate',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Modelos de e-mails',
				classes: { icon: 'icon-size-4 fa fa-envelope' },
				type: 'basic',
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/settings/mailsModels',
				},
				exactMatch: true,
			},
			{
				id: 0,
				title: 'Aviso por e-mail',
				type: 'basic',
				classes: { icon: 'icon-size-4 fa fa-bullhorn' },
				link: '/access-denied',
				badge: {
					title: '',
					classes: 'px-1 text-white rounded-full far fa-lock',
				},
				queryParams: {
					path: '/settings/mailWarning',
				},
				exactMatch: true,
			},
		],
	},
	{
		id: 0,
		title: 'Sistema',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Gateway',
				type: 'basic',
				icon: 'heroicons_outline:server-stack',
				link: '/admin/gateway',
			},
			{
				id: 0,
				title: 'Métricas',
				type: 'basic',
				icon: 'heroicons_outline:presentation-chart-bar',
				link: '/admin/metrics',
			},
			{
				id: 0,
				title: 'Saúde',
				type: 'basic',
				icon: 'heroicons_outline:heart',
				link: '/admin/health',
			},
			{
				id: 0,
				title: 'Configurações',
				type: 'basic',
				icon: 'heroicons_outline:lifebuoy',
				link: '/admin/configuration',
			},
			{
				id: 0,
				title: 'Logs',
				type: 'basic',
				icon: 'heroicons_outline:square-3-stack-3d',
				link: '/admin/logs',
			},
			{
				id: 0,
				title: 'Docs',
				type: 'basic',
				icon: 'heroicons_outline:document-text',
				link: '/admin/docs',
			},
		],
	},
	{
		id: 0,
		title: 'Desenvolvimento',
		subtitle: '',
		type: 'group',
		children: [
			{
				id: 0,
				title: 'Componentes',
				type: 'basic',
				icon: 'heroicons_outline:puzzle-piece',
				link: '/example/components',
			},
			{
				id: 0,
				title: 'Exemplo',
				type: 'basic',
				icon: 'heroicons_outline:sparkles',
				link: '/example',
			},
		],
	},
];
